<template>
  <div class="payout-summary-main">
    <div class="left-container">
      <div class="top-section">
        <Input placeholder="Year" :inputValue.sync="selectedYear" :isRequired="true" />
        <Button
          class="mt-1 ml-auto flex-shrink-0"
          style="width: fit-content"
          :disabled="previewDisabled"
          @click="previewClicked"
        >
          Preview
        </Button>
      </div>
      <div class="table-container">
        <TableBox
          title="Employees"
          :tableData="employeeList"
          :selectedRow.sync="selectedEmployee"
          :maxSelection="-1"
          :showSelectAll="true"
        />
      </div>
    </div>
    <div class="right-container" style="justify-content: center">
      <DesignerV2
        v-if="showReportPreview"
        :viewMode="true"
        :reportData="designerV2ReportData"
        reportFolder="ROTForm"
        :reportFile="designerV2ReportFiles"
        :canShare="true"
        :canClose="false"
        :downloadName="downloadFileName"
      />
      <div v-else class="print-placeholder"> Select a record and click on <strong>Preview</strong> to get started </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    previewDisabled() {
      return this.selectedEmployee.length == 0;
    },
  },
  data: function () {
    return {
      employeeList: [],
      selectedEmployee: [],

      selectedYear: '',

      showReportPreview: false,
      downloadFileName: '',
      designerV2ReportFiles: [],
      designerV2ReportData: [],
    };
  },
  methods: {
    previewClicked: async function () {
      this.$fullscreenLoading(`Loading Preview (0/${this.selectedEmployee.length})`);
      const reportData = [];
      let seq = 1;
      for (const e of this.selectedEmployee) {
        const details = await this.$apiCallV2('/DriverPayroll/PrintEAForm', {
          staffno: e['Employee ID'],
          year: this.selectedYear,
        });

        details['_year'] = this.selectedYear;
        details['_date'] = new Date().formatString('yyyy-MM-dd');
        details['Staff_StartDate'] =
          details['Staff_StartDate'] ? new Date(details['Staff_StartDate']).formatString('yyyy-MM-dd') : '';
        details['Staff_EndDate'] =
          details['Staff_EndDate'] ? new Date(details['Staff_EndDate']).formatString('yyyy-MM-dd') : '';

        // format address
        let address = `${details['Co_Name']}`;
        address += details['Co_Addr1'] ? `, ${details['Co_Addr1']}` : '';
        address += details['Co_Addr2'] ? `, ${details['Co_Addr2']}` : '';
        address += details['Co_Addr3'] ? `, ${details['Co_Addr3']}` : '';
        address += details['Co_Addr4'] ? `, ${details['Co_Addr4']}` : '';
        address += details['Co_PostCode'] ? `, ${details['Co_PostCode']}` : '';
        address += details['Co_City'] ? ` ${details['Co_City']}` : '';
        address += details['Co_State'] ? `, ${details['Co_State']}` : '';

        details['_address'] = address;

        // format currency
        details['TotalTaxableIncome'] = this.$currencyFormat(details['TotalTaxableIncome']);
        details['EmployeeBonus'] = this.$currencyFormat(details['EmployeeBonus']);
        details['TotalIncome'] = this.$currencyFormat(details['TotalIncome']);
        details['TotalIncomeTaxB4Zakat'] = this.$currencyFormat(details['TotalIncomeTaxB4Zakat']);
        details['EmployeeCP38'] = this.$currencyFormat(details['EmployeeCP38']);
        details['EmployeeZakat'] = this.$currencyFormat(details['EmployeeZakat']);
        details['EmployeeEPF'] = this.$currencyFormat(details['EmployeeEPF']);
        details['EmployeeSOCSO'] = this.$currencyFormat(details['EmployeeSOCSO']);

        reportData.push(details);
        this.$fullscreenLoading(`Loading Preview (${seq++}/${this.selectedEmployee.length})`);
      }

      this.downloadFileName = `EAForm_${new Date().formatString('yyyyMMddHHmm')}`;
      this.designerV2ReportFiles = Array.from({ length: this.selectedEmployee.length }, () => 'EAForm.json');
      this.designerV2ReportData = reportData;
      this.showReportPreview = true;
      this.$fullscreenLoading();
    },
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=HMS&page=Driver Batch Payroll`);
      if (sasControl.find((k) => k['Control'] == 'MnuPrintEAForm')) {
        // redirect to home page if no access
        await this.$showAlert('error', 'Access Denied', 'You do not have permission to access this page.');
        this.$router.push(`/Home/${this.$route.params['user']}`);
      }
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.$fullscreenLoading('Getting Details');
    this.employeeList = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'EMPLOYEE', module: 'MASTER' });

    if (this.$route.query['year']) {
      this.selectedYear = this.$route.query['year'];
    }

    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.payout-summary-main {
  font-size: 12px;
  padding: 10px 45px;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 6px;

  > .left-container,
  .right-container {
    height: 100%;
    width: 100%;
    padding: 5px;
    border-radius: 5px;
    overflow: hidden;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 6px;

    > .top-section {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    > .table-container {
      overflow: auto;
    }

    > .print-placeholder {
      text-align: center;
      font-size: 1.25rem;
      width: 100%;
    }
  }
}
</style>
